export const EDIT_ORGANIZATION = 'editOrganization';
